




































































































































































import {Vue, Component, Prop} from "vue-property-decorator";
import RestcommApplications from "@/consoleapi/api/restcomm/applications";
import ApplyNumbers from "@/components/applications/ApplyNumbers.vue";
@Component({
  components: {ApplyNumbers}
})
export default class ShowApplications extends Vue {
  @Prop() public sid!: string;

  public application = {
    "friendly_name": null,
    "visual_designer_url": null,
    "type": null,
    //""
  };

  private deleteModal = false;

  private applicationName = '';

  private referenceUrl = '';


  private numbers = [];

  showDeleteModal() {
    this.deleteModal = true;
  }

  closeDeleteModal() {
    this.deleteModal = false;
  }

  updateApplication() {
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.update(
        this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)),
        this.sid,
        this.applicationName,
        this.referenceUrl)
        .then(response => {
          this.application = response.data;
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  deleteApplication() {
    if (!confirm('この操作は取り消せません。本当に[' + String(this.application.friendly_name) + ']を削除しますか？')) {
      return;
    }
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.delete(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.sid)
        .then(response => {
          console.log(response.data);
          this.$router.push({name: 'applications'});
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  getApplications() {
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.find(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.sid)
        .then(response => {
          const application = response.data.application;
          this.numbers = response.data.numbers;
          console.log(response.data);
          this.applicationName = String(application.friendly_name);
          this.referenceUrl = String(application.rcml_url);
          this.application = response.data.application;
        })
        .catch(error => {
          console.log(error.response);
          this.$router.push({name: 'applications'});
        });
  }

  viewRVD(rvdUrl: string) {
    open(rvdUrl, "_blank");
  }

  mounted() {
    this.getApplications();
  }
}
